module.exports = __webpack_public_path__ + "static/img/device.01480d11.svg";